export const PAGE_LOADED = "page/loaded"

export const pageLoaded = () => ({
    type: PAGE_LOADED,
})
